<template>
  <div ref="container">
    <div class="searchGood list-part-refer liaison">
      <div class="row2 list-part-refer-con">
        <div class="list-part-refer-text">快速查询公司能否注册</div>
        <div class="form-top">
          <div class="score main-top-company">
            <Select
              class="liaison-city"
              v-model="params.companyCity"
              style="width: 120px"
            >
              <Option
                v-for="item in companyCity"
                :value="item.City"
                :key="item.City"
                >{{ item.City }}</Option
              >
            </Select>
            <Input v-model="params.keyword" placeholder="关键字" />

            <Select v-model="params.industryType" style="width: 120px">
              <Option
                v-for="item in industryType"
                :value="item.industry"
                :key="item.industry"
                >{{ item.industry }}</Option
              >
            </Select>

            <Select v-model="params.orgType" style="width: 120px">
              <Option
                v-for="item in orgType"
                :value="item.org"
                :key="item.org"
                >{{ item.org }}</Option
              >
            </Select>
            <div class="liaison-btn bg-color-red" @click="submit">立即核名</div>
          </div>
        </div>
      </div>
    </div>

    <div class="searchGood liaison-list">
      <div class="search acea-row row-between-wrapper">
        <p>
          当前核名结果为本站数据匹配结果，仅供参考，最终核名结果请以工商审核为准。
        </p>
      </div>
      <Row class="cabinet">
        <i-col span="8">
          <div class="cabinet-details">
            <span>你检索的商号</span>
            <p class="company">{{ searchInfo }}</p>
          </div>
        </i-col>
        <i-col span="8">
          <div class="cabinet-details">
            <span>通过率</span>
            <p class="passing">低</p>
          </div>
        </i-col>
        <i-col span="8">
          <div class="cabinet-details">
            <span>建议你咨询专家</span>
            <p class="consult">
              <a @click.prevent="$kefu.OnlineConsultation" href>咨询专家</a>
            </p>
          </div>
        </i-col>
      </Row>
      <div class="search acea-row row-between-wrapper">
        <p v-if="Paging.TotalRecords > 0">
          发现相同或相似名称企业 共有{{ Paging.TotalRecords }}个结果
        </p>
        <p v-else>没有相同或相似名称的企业</p>
      </div>
      <Row class="cabinet-list-title">
        <i-col span="12">企业名称</i-col>
        <i-col span="12">相似度</i-col>
      </Row>
      <CompanyList
        :searchList="searchList"
        :searchInfo="searchInfo"
      ></CompanyList>
      <Loading
        :loaded="loadend"
        :loading="loading"
        v-if="searchList.length"
      ></Loading>
    </div>
    <div class="noCommodity" v-cloak>
      <!-- <div class="noPictrue">
        <img src="@assets/images/noSearch.png" class="image" />
      </div> -->
      <recommend productType="companyHot"></recommend>
    </div>

    <div
      class="noCommodity"
      v-cloak
      v-if="searchList.length === 0 && where.pageIndex > 1"
    >
      <!-- <div class="noPictrue">
        <img src="@assets/images/noSearch.png" class="image" />
      </div> -->
      <recommend productType="companyHot"></recommend>
    </div>
    <Modal v-model="customerShow" draggable scrollable title="错误">
      <div>{{ customerMessage }}</div>
    </Modal>
  </div>
</template>
<script>
import Loading from "@components/Loading";
import CompanyList from "@components/CompanyList";
import { trim } from "@utils";
import { queryCompany, getCompanyParam } from "@api/public";
import { chs, required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { mapGetters } from "vuex";
// import Recommend from "@components/Recommend";

export default {
  name: "GoodSearch",
  components: {
    CompanyList,
    Loading
    // Recommend,
  },
  computed: {
    searchInfo: example =>
      example.where.companyCity +
      example.where.keyword +
      example.where.industryType +
      example.where.orgType,
    ...mapGetters(["username"])
  },
  watch: {
    params: {
      handler() {
        this.updateUrl();
      },
      deep: true
    },
    username(newName, oldName) {
      if (
        typeof newName === "string" &&
        newName !== "" &&
        typeof oldName === "string" &&
        oldName === ""
      ) {
        this.mountedStart();
      }
    }
  },
  mounted: function() {
    this.mountedStart();
  },
  data: function() {
    return {
      search: "",
      params: {
        keyword: "",
        companyCity: "",
        industryType: "",
        orgType: ""
      },
      where: {
        pageIndex: 1,
        pageSize: 20,
        keyword: "",
        companyCity: "",
        industryType: "",
        orgType: ""
      },
      loading: false,
      loadend: false,
      searchList: [],
      query: false,
      companyCity: [],
      industryType: [],
      orgType: [],
      Paging: [],
      customerShow: false,
      customerMessage: ""
    };
  },

  methods: {
    // 生命周期函数mounted映射
    mountedStart() {
      // this.$scroll(this.$refs.container, () => {
      //   !this.loading && this.getCompanyList();
      // });
      if (!this.$route.query.keyword) this.query = true;
      this.initParam();
      this.getCompanyParam();
      console.log(typeof this.params.keyword);
      if (typeof this.params.keyword != undefined && this.params.keyword != '' ) this.submit();
    },
    // 根据条件监听并改变url地址
    updateUrl() {
      this.$router.replace({
        query: {
          keyword: this.params.keyword,
          companyCity: this.params.companyCity,
          industryType: this.params.industryType,
          orgType: this.params.orgType
        }
      });
    },
    // 把get参数存入params
    initParam() {
      for (let key in this.params) {
        if (typeof this.$route.query[key] != undefined)
          this.params[key] = this.$route.query[key];
      }
    },
    // 获取公司核名所需参数
    getCompanyParam() {
      this.params.keyword =
        typeof this.params.keyword == "undefined" ? "" : this.params.keyword;
      getCompanyParam().then(res => {
        this.$set(this, "companyCity", res.data.companyCity);
        this.$set(this, "industryType", res.data.industryType);
        this.$set(this, "orgType", res.data.orgType);

        // 默认选中第一个
        let cityTemp = false;
        if (res.data.companyCity.length > 0)
          res.data.companyCity.find(value => {
            if (value.City == this.params.companyCity) cityTemp = true;
          });
        if (cityTemp == false)
          this.params.companyCity = res.data.companyCity[0].City;

        let industryTemp = false;
        if (res.data.industryType.length > 0)
          res.data.industryType.find(value => {
            if (value.industry == this.params.industryType) industryTemp = true;
          });
        if (industryTemp == false && res.data.industryType.length > 0)
          this.params.industryType = res.data.industryType[0].industry;

        let orgTemp = false;
        if (res.data.orgType.length > 0)
          res.data.orgType.find(value => {
            if (value.org == this.params.orgType) orgTemp = true;
          });
        if (orgTemp == false && res.data.orgType.length > 0)
          this.params.orgType = res.data.orgType[0].org;

        this.setWhere();
      });
    },
    // 设置where
    setWhere() {
      this.where.pageIndex = 1;
      for (const key in this.params) {
        this.where[key] = this.params[key];
      }
    },
    submit() {
      // 初始化搜索数据
      this.$set(this, "searchList", []);
      this.loadend = false;
      this.loading = false;
      this.setWhere();
      this.getCompanyList();
    },
    async getCompanyList() {
      if (this.loading) return; //阻止下次请求（false可以进行请求）；
      if (this.loadend) return; //阻止结束当前请求（false可以进行请求）；

      const keyword = trim(this.where.keyword);
      // console.log(keyword);

      try {
        await this.$validator({
          keyword: [
            chs(chs.message("关键字")),
            required(required.message("关键字"))
          ]
        }).validate({ keyword });
      } catch (err) {
        this.$dialog.toast({ mes: err.msg });
        return validatorDefaultCatch(err);
      }

      this.loading = true;
      queryCompany(this.where)
        .then(res => {
          this.loading = false;
          this.searchList.push.apply(this.searchList, res.data.Result);
          this.Paging = res.data.Paging;
          this.loadend =
            res.data.Paging.pageIndex * res.data.Paging.PageSize >=
            res.data.Paging.TotalRecords; //判断所有数据是否加载完成；

          this.where.pageIndex = parseInt(this.where.pageIndex) + 1;
        })
        .catch(err => {
          this.loading = false;
          if (typeof err.data != "undefined" && err.data.status == 400) {
            this.$Modal.confirm({
              title: "错误",
              content:
                err.data.msg.indexOf("请求次数") != -1
                  ? err.data.msg + "，请与客服沟通。"
                  : err.data.msg,
              okText: "客服",
              cancelText: "取消",
              closable: true,
              onOk: () => {
                this.$kefu.OnlineConsultation();
              }
            });
          }
          this.$dialog.toast({ mes: err.msg });
        });
    }
  }
};
</script>
<style scoped>
.noCommodity {
  width: 1200px;
  margin: auto;
  background: #fff;
}
</style>
